import React from 'react';
import { Layout, Typography, Card, Row, Col, Button } from 'antd';
import { FaEye } from 'react-icons/fa';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const jobs = [
    {
        title: 'AI Engineer',
        description: 'Develop and deploy AI models to solve real-world problems.',
        location: 'Nairobi, Kenya',
    },
    {
        title: 'Cybersecurity Specialist',
        description: 'Protect systems and data from cyber threats.',
        location: 'Lagos, Nigeria',
    },
    {
        title: 'Data Scientist',
        description: 'Analyze and interpret complex data to drive business decisions.',
        location: 'Cape Town, South Africa',
    },
    {
        title: 'Software Developer',
        description: 'Build scalable and robust software applications.',
        location: 'Accra, Ghana',
    },
    {
        title: 'AI Research Scientist',
        description: 'Conduct research to advance AI and machine learning.',
        location: 'Cairo, Egypt',
    },
    {
        title: 'Network Security Engineer',
        description: 'Ensure the security and integrity of enterprise networks.',
        location: 'Kampala, Uganda',
    },
    {
        title: 'Big Data Engineer',
        description: 'Design and maintain large-scale data processing systems.',
        location: 'Dar es Salaam, Tanzania',
    },
    {
        title: 'DevOps Engineer',
        description: 'Automate and streamline development and deployment processes.',
        location: 'Addis Ababa, Ethiopia',
    },
];

function AICareers() {
    return (
        <Layout>
            <Content style={{ padding: '60px', background: 'linear-gradient(135deg, #e6fffb, #fff7e6)', minHeight: '100vh' }}>
                <Title level={2} style={{ fontSize: '20px', display: 'flex', alignItems: 'center', color: '#13c2c2', marginBottom: '28px', fontWeight: '700' }}>
                    <FaEye style={{ marginRight: '14px', fontSize: '26px', color: '#fa8c16' }} /> AI Careers
                </Title>
                <Paragraph style={{ fontSize: '16px', color: '#595959', marginBottom: '32px', maxWidth: '800px', lineHeight: '1.6' }}>
                    Join the forefront of innovation with JectHub’s AI team. We’re seeking passionate individuals in Artificial Intelligence, Machine Learning, and Data Science to shape the future. Explore our opportunities and ignite your career today!
                </Paragraph>
                <Row gutter={[24, 24]}>
                    {jobs.map((job, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            <Card
                                hoverable
                                style={{
                                    borderRadius: '16px',
                                    overflow: 'hidden',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                    background: 'linear-gradient(135deg, #ffffff, #f0fafa)',
                                    height: '300px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    padding: '20px',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-8px)';
                                    e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.background = 'linear-gradient(135deg, #f0fafa, #e6fffb)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
                                    e.currentTarget.style.background = 'linear-gradient(135deg, #ffffff, #f0fafa)';
                                }}
                            >
                                <div>
                                    <Title level={4} style={{ marginBottom: '12px', color: '#1a1a1a', fontSize: '20px', fontWeight: '600' }}>
                                        {job.title}
                                    </Title>
                                    <Paragraph
                                        style={{ color: '#595959', fontSize: '14px', marginBottom: '16px', lineHeight: '1.5' }}
                                        ellipsis={{ rows: 2, expandable: false }}
                                    >
                                        {job.description}
                                    </Paragraph>
                                    <Paragraph style={{ marginBottom: '0', color: '#888', fontSize: '13px' }}>
                                        <strong style={{ color: '#13c2c2' }}>Location:</strong> {job.location}
                                    </Paragraph>
                                </div>
                                <Button
                                    type="primary"
                                    icon={<FaEye style={{ marginRight: '8px' }} />}
                                    style={{
                                        background: 'linear-gradient(45deg, #fa8c16, #d46b08)',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontWeight: 'bold',
                                        height: '44px',
                                        width: '100%',
                                        marginTop: '20px',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.background = 'linear-gradient(45deg, #d46b08, #ad4e00)';
                                        e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.background = 'linear-gradient(45deg, #fa8c16, #d46b08)';
                                        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                                    }}
                                >
                                    View Details
                                </Button>
                            </Card>
                        </Col>
                    ))}
                </Row>
                {/* Custom CSS */}
                <style jsx global>{`
                    .ant-card {
                        animation: fadeIn 0.5s ease-in-out;
                    }
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(10px); }
                        100% { opacity: 1; transform: translateY(0); }
                    }
                `}</style>
            </Content>
        </Layout>
    );
}

export default AICareers;